import React from 'react';
import { ReviewTermsTable } from './ReviewTermsTable';
import { ReviewTermsLocationNameDialog } from './ReviewTermsLocationNameDialog';
import '../../styles/ReviewTerms.scss';

export const ReviewTerms = ({
  apiDetails,
  apiIntegrationDetails: { locationsGroupByApi },
  subscriptionData,
  solutionData,
}) => {
  const { id } = apiDetails;
  const integrationsDataPerLocation = locationsGroupByApi[id];

  return (
    <div className="review-terms__container" data-testid='review-terms-step'>
      <ReviewTermsLocationNameDialog />
      <ReviewTermsTable
        apiDetails={apiDetails}
        integrationsDataPerLocation={integrationsDataPerLocation}
        solutionData={solutionData}
        subscriptionData={subscriptionData}
      />
    </div>
  );
};
